import * as z from "zod/v4";

/** An iso datetime string that is compatible with supabase's iso strings */
export const IsoDateTimeSchema = z.iso
  .datetime({ offset: true })
  .describe("Datetime string (ISO format)");
export type IsoDateTime = z.infer<typeof IsoDateTimeSchema>;
